const value = {
    learningTitle: 'Learning',
    skillsMap: 'Expertise map',
    usersRating: 'Leaderboard',
    findByContext: 'Name of context of unit',
    showUnits: 'Show units',
  };

export default value;
